//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    filter: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      yesNoPartialOptions: [
        { label: 'Любое', value: 'any' },
        { label: 'Да', value: 'yes' },
        { label: 'Да или частично', value: 'yesOrPartial' },
        { label: 'Только частично', value: 'onlyPartial' },
        { label: 'Нет или частично', value: 'noOrPartial' },
        { label: 'Нет', value: 'no' }
      ],
      yesNoAnyOptions: [
        { label: 'Любое', value: 'any' },
        { label: 'Да', value: 'yes' },
        { label: 'Нет', value: 'no' }
      ]
    }
  }
}

